import Vue from "vue";
import router from "@/router/index";
import Home from "@/views/templates/default2022NoSearchBar/Home.vue";
import Login from "@/views/templates/default2022NoSearchBar/Login.vue";
import Validation from "@/views/templates/default2022NoSearchBar/Validation.vue";
import Error from "@/views/templates/default2022NoSearchBar/Error.vue";
import NotSupported from "@/views/templates/default2022NoSearchBar/NotSupported.vue";
import AuthError from "@/views/templates/default2022NoSearchBar/AuthError.vue";
import Mantainance from "@/views/templates/default2022NoSearchBar/Mantainance.vue";
import { mapGetters } from "vuex";
import SurveyCompiled from "@/views/templates/default2022NoSearchBar/SurveyCompiled.vue";
export default Vue.extend({
    computed: {
        ...mapGetters('auth', {
            nextRoute: "getNextRoute"
        })
    },
    props: {
        templateName: String,
        customerCode: String,
        templateConfig: {}
    },
    data() {
        return {};
    },
    mounted() {
        router.addRoute({ path: '/:customerCode', name: 'HomeTemplate', component: Home, props: { templateName: this.templateName } });
        router.addRoute({ path: '/:customerCode/open/:codeTag', name: 'Autopilot', component: Home, props: { templateName: this.templateName } });
        router.addRoute({ path: '/:customerCode/mantainance', name: 'Mantainance', component: Mantainance, props: true });
        router.addRoute({ path: '/:customerCode/authError', name: 'AuthError', component: AuthError, props: true });
        router.addRoute({ path: '/:customerCode/notSupported', name: 'NotSupported', component: NotSupported, props: true });
        router.addRoute({ path: '/:customerCode/error', name: 'Error', component: Error, props: true });
        router.addRoute({ path: '/:customerCode/validation', name: 'Validation', component: Validation, props: true });
        router.addRoute({ path: '/:customerCode/login', name: 'Login', component: Login, props: true });
        router.addRoute({ path: '/:customerCode/surveyCompiled', name: 'SurveyCompiled', component: SurveyCompiled, props: true });
        let rotta = { name: 'HomeTemplate' };
        if (this.nextRoute) {
            rotta = { path: this.nextRoute };
            this.$store.dispatch("auth/setNextRoute", undefined);
        }
        router.push(rotta);
    },
    methods: {},
    components: {
        Home,
        Login,
        Validation,
        Error,
        NotSupported,
        AuthError,
        Mantainance
    },
});
